module.exports = __webpack_public_path__ + "static/media/google-color.313ff7ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/google-color.svg
// module id = 2405
// module chunks = 0